import { IOffer, IStats } from '../../types/offer';

export function getBuilderStatsFromOffer(offer: IOffer): IStats | null {
  const { builder } = offer;

  if (builder?.stats == null) {
    return null;
  }

  return builder.stats;
}
